import type { FieldProps } from './types';

/**
 * Ids of the help and error elements a control should reference in `aria-describedby`.
 *
 * @param {string} id -- The control id.
 * @returns The two ids.
 */
export const fieldIds = (id: string) => ({ help: `${id}-help`, error: `${id}-error` });

/**
 * Label, control, help and error laid out the same way everywhere.
 */
export const Field = ({ id, label, help, error, required, children }: FieldProps) => {
  const ids = fieldIds(id);
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-sm font-medium text-gray-700">
        {label}
        {required ? <span className="text-danger-600"> *</span> : null}
      </label>
      {children}
      {help && !error ? (
        <p id={ids.help} className="text-xs text-gray-500">
          {help}
        </p>
      ) : null}
      {error ? (
        <p id={ids.error} role="alert" className="text-xs text-danger-600">
          {error}
        </p>
      ) : null}
    </div>
  );
};
